<template>
  <div class="card-body">
      <form id="form" @submit.prevent="submitReview">
        <div class="form-group">
          <label>Full name:</label>
          <input
            required
            type="text"
            class="form-control names"
            v-model="newreview.name"
          />
          <p>Please rate me:</p>
          <rating
            style="margin-top:-25px;"
            :grade="3"
            :maxStars="5"
            :hasCounter="false"
          />
          <label>Feedback:</label>
          <textarea
            wrap="hard"
            style="resize: none;"
            placeholder="Add description here"
            class="form-control names descritpion"
            v-model="newreview.more"
          >
          </textarea>
          <label class="uploadbutton form-control">
            <input
              type="file"
              id="file"
              ref="myFiles"
              accept="image/*"
            >Click here to Upload Image
          </label>
        </div>
        <div>
          <input
            type="submit"
            class="button-icon"
            value="Submit"
          />
        </div>
      </form>
    </div>
</template>

<script>
import db from '../../../config/db'
import Swal from 'sweetalert2'
import rating from '../star/starCreate.vue'

export default {
  components: {
    rating
  },
  data () {
    return {
      newreview: {
        name: '',
        image: '',
        rating: '',
        more: ''
      },
      files: ''
    }
  },
  mounted () {
    const form = document.getElementById('form')

    form.addEventListener('focus', (event) => {
      this.$store.commit('checkFormFocus', true)
    }, true)

    form.addEventListener('blur', (event) => {
      this.$store.commit('checkFormFocus', false)
    }, true)
  },
  methods: {
    notication (text, icon) {
      Swal.fire({
        title: text,
        icon: icon,
        timer: 3000,
        showConfirmButton: false
      })
    },
    submitReview () {
      const vm = this
      try {
        vm.addDB()
        vm.storeFiles()
        vm.notication('Success', 'success')
        vm.newreview = {}
      } catch (error) {
        console.error(error)
        vm.notication('Error occured', 'error')
      }
    },
    addDB () {
      if (this.$refs.myFiles.files.length === 1) {
        this.newreview.image = this.$refs.myFiles.files[0].name
      } else {
        this.newreview.image = 'no-image.png'
      }
      db.firestore.collection('/reviews').add({
        name: this.newreview.name,
        image: this.newreview.image,
        rating: this.$store.state.rating,
        more: this.newreview.more,
        date: new Date()
      }).then(setTimeout(() => { location.reload() }, 2000))
    },
    storeFiles () {
      if (this.newreview.image !== 'no-image.png') {
        const fileInfo = this.$refs.myFiles.files[0]
        db.storing.ref(
          'images/' + fileInfo.name
        ).put(fileInfo)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./form.scss";

label.uploadbutton {
  display: flex;
  flex-direction: column-reverse;
  padding-right: 15px;
  color: $media-colour;
  font-size: 1.5rem;
  text-decoration:none;
  cursor: pointer;
  margin-bottom: 5px;

  @media (max-width: 760px) {
    font-size: 1rem;
  }

  input {
    width: 300px;
    margin : 0 auto;
  }
}

</style>
